var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.68077 24H0.580757V7.95H5.68077V24ZM3.13076 5.7C1.48076 5.7 0.280762 4.5 0.280762 2.85C0.280762 1.2 1.63076 0 3.13076 0C4.78076 0 5.98077 1.2 5.98077 2.85C5.98077 4.5 4.78076 5.7 3.13076 5.7ZM24.2808 24H19.1808V15.3C19.1808 12.75 18.1308 12 16.6308 12C15.1308 12 13.6308 13.2 13.6308 15.45V24H8.53076V7.95H13.3308V10.2C13.7808 9.15 15.5808 7.5 18.1308 7.5C20.9808 7.5 23.9808 9.15 23.9808 14.1V24H24.2808Z",
    fill: "#000033"
  })));
};
export default SvgLinkedin;